<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">
        {{ 'shared.callPhone.title' | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-hidden="true"
        (click)="onClose()"
      ></button>
    </div>
    <div class="modal-body">
      <div class="flex w-full flex-col items-start gap-2">
        @if(dialing){
          <div class="w-full text-center my-4">
            <i class="fas fa-phone me-2"></i>
            <span>{{ 'shared.callPhone.dialing' | translate }}</span>
          </div>
        }
        @if(calling){
          <div class="w-full text-center my-4">
            <span class="text-2xl font-mono">{{ formatTimeCall() }}</span>
          </div>
          <p class="font-black text-[20px] justify-center text-black mt-2.5">
            {{ 'shared.callPhone.callInProgress' | translate }}
          </p>
        }
        @if(callEnded){
          <div class="w-full text-center my-4">
            <div class="w-full text-center my-4">
              <i class="fas fa-phone me-2"></i>
              <span>{{ 'shared.callPhone.callEnded' | translate }}</span>
            </div>
            <div class="p-3 border rounded">
              <p class="mb-1">{{ 'shared.callPhone.callDuration' | translate }}</p>
              <span class="text-2xl font-mono">{{ finalDuration }}</span>
            </div>
          </div>
        }

        @if (!callEnded && !calling && !dialing) {
          <h4 class="font-black text-[20px] justify-center text-black mt-2.5">
            {{ 'shared.callPhone.callTo' | translate:{ name: data.name } }}
          </h4>
          <h6 class="text-zinc-400 font-light text-sm my-2">
            {{ 'shared.callPhone.callToNumber' | translate:{ phone: data.phone } }}
          </h6>
        }

        @if (dialing) {
          <p class="font-black text-[20px] justify-center text-black mt-2.5">
            {{ 'shared.callPhone.waitingForCustomer' | translate }}
          </p>
        }
      </div>
    </div>
    <div class="modal-footer">
      @if(!calling && !dialing && !callEnded){
        <button
        class="btn btn-primary"
        (click)="startCallWavoip()">{{ 'shared.callPhone.callButton' | translate }}</button>
      }
      @if(calling || dialing){
        <button
        class="btn btn-primary"
        (click)="endCallWavoip()">{{ 'shared.callPhone.endButton' | translate }}</button>
      }
      @if(callEnded){
        <button
        class="btn btn-secondary"
        (click)="_matDialogRef.close()">{{ 'shared.callPhone.closeButton' | translate }}</button>
      }
    </div>
  </div>
</div>